import { Schema } from "@effect/schema";
import { ProtocolKey } from "../protocol";
import { ChainKey } from "../chain";
import { Address } from "../address";
import { PositionType } from "../position";

export type ShareTokenMeta = typeof ShareTokenMeta.Type;
export type ShareTokenMetaEncoded = typeof ShareTokenMeta.Encoded;

export const ShareTokenMeta = Schema.Struct({
  protocolKey: ProtocolKey,
  chainKey: ChainKey,
  marketAddress: Address,
  tokenAddress: Address,
  shareTokenAddress: Address,
  positionType: PositionType,
}).annotations({ identifier: "ShareTokenMeta" });
